(function () {

    /* Load Script function we may need to load jQuery from the Google's CDN */
    /* That code is world-reknown. */
    /* One source: http://snipplr.com/view/18756/loadscript/ */

    var loadScript = function (url, callback) {

        var script = document.createElement("script");
        script.type = "text/javascript";

        // If the browser is Internet Explorer.
        if (script.readyState) {
            script.onreadystatechange = function () {
                if (script.readyState == "loaded" || script.readyState == "complete") {
                    script.onreadystatechange = null;
                    callback();
                }
            };
            // For any other browser.
        } else {
            script.onload = function () {
                callback();
            };
        }

        script.src = url;
        document.getElementsByTagName("head")[0].appendChild(script);

    };

    /* This is my app's JavaScript */
    var myAppJavaScript = function ($) {
        // $ in this scope references the jQuery object we'll use.
        // Don't use jQuery, or jQuery191, use the dollar sign.
        // Do this and do that, using $.

        var url = window.location.href;

        var nowtime = new Date();

        var domainname = window.location.hostname;
        var url = window.location.href;
        var originalurl = window.location.href.split('?')[0];
        var pathslist = originalurl.split('/');

        var laststring = pathslist[pathslist.length - 1];
        var productstring = pathslist[pathslist.length - 2];

       $(document).ready(function () {
         $('.swatchy_colordiv').click(function(e){
          var _swatchElement = e.currentTarget;
           var _ColorName = _swatchElement.getAttribute('swatchy-data-color');
           var _productid = _swatchElement.getAttribute('data-productid');
           var _colornamespan = document.getElementById('ca_color_name_' + _productid);
           _colornamespan.innerText = _ColorName;
         });
       });

        

    };

    /* If jQuery has not yet been loaded or if it has but it's too old for our needs,
          we will load jQuery from the Google CDN, and when it's fully loaded, we will run
          our app's JavaScript. Set your own limits here, the sample's code below uses 1.9.1
          as the minimum version we are ready to use, and if the jQuery is older, we load 1.9.1 */
    if ((typeof jQuery === 'undefined') || (parseInt(jQuery.fn.jquery) === 1 && parseFloat(jQuery.fn.jquery.replace(/^1\./, "")) < 9.1)) {
        loadScript('//ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js', function () {
            jQuery191 = jQuery.noConflict(true);
            myAppJavaScript(jQuery191);
        });
    } else {
        myAppJavaScript(jQuery);
    }

})();